module.exports = __webpack_public_path__ + "static/media/pic6.2363a7ea.jpg";